<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div style="overflow-x: auto">
      <table aria-label="Tableau affichant les animaux ajouté via Boviclic"
             class="table table-bordered table-striped table-border-purple table-head-purple">
        <thead>
        <tr>
          <th scope="col" class="text-center">#</th>
          <th scope="col" class="text-center" i18n="@@animalSpecies">Species</th>
          <th scope="col" class="text-center" i18n="@@animalCategory">Category</th>
          <th scope="col" class="text-center" i18n="@@animalGender">Gender</th>
          <th scope="col" class="text-center" i18n="@@country">Country</th>
          <th scope="col" class="text-center" i18n="@@animalNumber">Number</th>
          <th scope="col" class="text-center" i18n="@@quantity">Quantity</th>
          <th scope="col" class="text-center" i18n="@@autopsy">Autopsy</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let d of data; let i = index">
          <th scope="row" class="text-center">{{i + 1}}</th>
          <td class="text-center">{{ d?._embedded?.animalSpecies?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.animalCategory?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.animalGender?.code }}</td>
          <td class="text-center">{{ d?._embedded?.country?.alpha2 }}</td>
          <td class="text-center">{{ d?.number }}</td>
          <td class="text-center">{{ d?.quantity }}</td>
          <td align="center" class="pl-4 pr-4">
            <app-select-autopsies [showLabel]="false" [formGroup]="autopsyFormGroup(i)" [index]="i"
                                  *ngIf="showAutopsy(d)" (updated)="onAutopsyChange($event, i)"></app-select-autopsies>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
